<template>
  <div
    class="nt-quote"
    :class="quoteAside ? 'nt-quoteAside' : undefined"
    :style="{ backgroundColor: backgroundColor, color: textColor }"
  >
    <span
      class="nt-quote__arrow nt-quote__arrow--left"
      :style="{ alignItems: quoteDirection }"
    >
      <c-icon
        name="left-quote"
        size="xl"
        :color="quoteColor"
      />
    </span>
    <div class="nt-quote__quotationWrapper">
      <blockquote :style="{ textAlign: quoteText }">
        <slot name="quote" />
      </blockquote>
      <div
        class="nt-quote__credits"
        :style="{ textAlign: credits }"
      >
        <h2 class="nt-quote__author">
          <slot name="author" />
        </h2>
        <h3 class="nt-quote__authorRole">
          <slot name="author_role" />
        </h3>
      </div>
    </div>
    <span
      class="nt-quote__arrow nt-quote__arrow--right"
      :style="{ alignItems: quoteDirection }"
    >
      <c-icon
        name="right-quote"
        size="xl"
        :color="quoteColor"
      />
    </span>
  </div>
</template>

<script>
export default {
  name: 'NtQuote',
  props: {
    textColor: String,
    backgroundColor: String,
    quoteDirection: {
      type: String,
      default: 'flex-start'
    },
    quoteText: {
      type: String,
      default: 'left'
    },
    credits: {
      type: String,
      default: 'center'
    },
    quoteColor: {
      type: String,
      default: '#000000'
    },
    quoteAside: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.nt-quote {
  padding: 1.25rem 0;

  &__arrow {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;

    &--left {
      margin-bottom: 1.25rem;
    }

    &--right {
      margin-top: 1.25rem;
    }
  }

  &__quotationWrapper,
  blockquote {
    margin: 0 0 1.25rem;
    font-style: italic;
    font-size: 1.25rem;
    font-weight: 400;
    line-height: 1.6;
    padding-inline: 0.2rem;

    @media screen and (min-width: 768px) {
      font-size: 1.5rem;
    }
  }

  &__credits {
    font-weight: bold;
    font-size: 1rem;
    line-height: 1.8;

    @media screen and (min-width: 768px) {
      font-size: 1.25rem;
    }
  }

  &__author,
  &__authorRole {
    margin: 0;
  }
}

.nt-quoteAside {
  display: flex;
  flex-direction: row;

  .nt-quote__arrow {
    width: unset;

    &--left {
      justify-content: flex-start;
      margin-bottom: 0;
    }

    &--right {
      margin-top: 0;
      justify-content: flex-end;
    }
  }
}
</style>
